<template>
	<div>
		<el-dialog
			:visible.sync="DialogDetailedReport"
			:before-close="handleClose"
			:fullscreen="false"
			width="600px"
			title="Download Detailed report"
			class="header"
		>
			<el-row>
				<el-col :span="24" :offset="0">
					<span>Location </span>
					<el-select
						v-model="detailedLocations"
						v-validate="'required'"
						multiple
						collapse-tags
						style="margin-top: 10px"
						class="select"
						filterable
						:clearable="true"
						placeholder="Select Location"
						name="Select"
					>
						<div
							class="px-4 py-2 text-sm font-semibold text-amplitude flex items-center justify-between"
						>
							<span
								class="cursor-pointer ns-short-act-dr"
								@click="handleShortAct(1)"
								>Select All</span
							>
							<span
								class="cursor-pointer ns-short-act-dr"
								@click="handleShortAct(0)"
								>Clear</span
							>
						</div>
						<el-option
							v-for="(item, key) in allComputedLocations"
							:key="key"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
					<p>
						<span :v-show="errors.has(`Select`)" class="text-red-dark text-xs">
							{{ errors.first(`Select`) ? "This field is required" : "" }}
						</span>
					</p>
				</el-col>
			</el-row>
			<el-row style="margin-top: 20px">
				<el-col :span="11" :offset="0">
					<div>From</div>
					<el-date-picker
						style="margin-top: 10px; width: 100%"
						v-model="detailedFromDate"
						type="date"
						placeholder="Select Date"
						class="date"
						format="yyyy-MM-dd"
						v-validate="'required'"
						name="from_date"
					>
						<!-- :picker-options="datePickerOptions" -->
					</el-date-picker>
					<p>
						<span
							:v-show="errors.has(`from_date`)"
							class="text-red-dark text-xs"
						>
							{{ errors.first(`from_date`) ? "This field is required" : "" }}
						</span>
					</p>
				</el-col>
				<el-col :span="11" :offset="2">
					<div>To</div>
					<el-date-picker
						style="margin-top: 10px; width: 100%"
						v-model="detailedToDate"
						type="date"
						placeholder="Select Date"
						class="date"
						format="yyyy-MM-dd"
						v-validate="'required'"
						name="to_date"
					>
						<!-- :picker-options="fromDatePickerOptions" -->
					</el-date-picker>
					<p>
						<span :v-show="errors.has(`to_date`)" class="text-red-dark text-xs">
							{{ errors.first(`to_date`) ? "This field is required" : "" }}
						</span>
					</p>
				</el-col>
			</el-row>
			<el-row style="margin-top: 20px">
				<el-col :span="24">
					<span style="margin-right: 3px"
						><b><u>Note</u> - </b></span
					>Please select less than or equal to {{ days }} days to download
					detailed report<span></span>
				</el-col>
			</el-row>
			<el-row style="margin-top: 0px">
				<el-col style="margin-top: 40px" :span="4" :offset="12">
					<el-button
						@click="cancel()"
						class="button-class-white2"
						style="border: none"
					>
						Cancel
					</el-button>
				</el-col>
				<el-col :span="7" :offset="1">
					<el-button
						@click="go_back()"
						class="button-class"
						style="border: none"
					>
						Download Report
					</el-button>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
var moment = require("moment");
import { mapState, mapActions } from "vuex";
import formBuilderServices from "../../../../services/formBuilderServices";

export default {
	props: {
		DialogDetailedReport: Boolean,
		all_locations: Array,
		project_tasks: String,
		project_tasksItems: Array,
		locations: Array,
		from_date:null,
		to_date:null,
	},
	data: () => ({
		moment: moment,
		detailedLocations: [],
		detailedFromDate: "",
		detailedToDate: "",
		datePickerOptions: {
			firstDayOfWeek: 1,
			disabledDate(date) {
				return date > moment().subtract(0, "days");
			},
		},
		days: 0,
	}),
	computed: {
		fromDatePickerOptions() {
			return {
				firstDayOfWeek: 1,
				disabledDate: (date) => {
					// Disable dates greater than the current date
					const currentDate = new Date();
					if (date > currentDate) {
						return true;
					}

					// Disable dates less than detailedFromDate or greater than detailedToDate
					if (this.detailedFromDate) {
						return date < this.detailedFromDate;
					}

					// If detailedFromDate or detailedToDate is not selected, no date is disabled
					return false;
				},
			};
		},
		allComputedLocations() {
			let location_list = [];
			if (this.all_locations.length) {
				location_list = this.all_locations.sort((a, b) =>
					a.name < b.name ? -1 : 1
				);
			}
			return location_list;
		},
	},
	watch: {
		DialogDetailedReport(val) {
			if (val) {
				this.detailedLocations = [];
				this.detailedFromDate = "";
				this.detailedToDate = "";
				this.detailedLocations = this.locations;
				this.detailedFromDate = this.from_date;
				this.detailedToDate = this.to_date;

				let freq = [...this.project_tasksItems].filter((el) => {
					if (el.id == this.project_tasks) {
						return el.frequency;
					}
				});
				this.days =
					freq[0].frequency == "daily"
						? 31
						: freq[0].frequency == "weekly"
						? 61
						: freq[0].frequency == "monthly"
						? 92
						: freq[0].frequency == "quarterly"
						? 92
						: 31;
				this.$validator.reset();
				this.all_locations = this.all_locations.sort((a, b) =>
					a.name < b.name ? -1 : 1
				);
				if(this.detailedLocations.length==0){
					this.handleShortAct(1)
				}
			}
		},
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		cancel() {
			this.$emit("closed");
		},
		handleShortAct(action) {
			if (action) {
				this.detailedLocations = [];
				for (const elm of this.allComputedLocations) {
					if (
						!(
							this.detailedLocations.length === this.allComputedLocations.length
						)
					)
						this.detailedLocations.push(elm.id);
				}
			} else {
				this.detailedLocations = [];
			}
		},
		disableFromDatePickerDates(date) {
			if (!this.detailedFromDate) {
				return date > moment().subtract(0, "days");
			}

			return date > moment().subtract(0, "days");
		},
		go_back() {
			let freq = [...this.project_tasksItems].filter((el) => {
				if (el.id == this.project_tasks) {
					return el.frequency;
				}
			});
			console.log(freq, "freq");
			let days =
				freq[0].frequency == "daily"
					? 31
					: freq[0].frequency == "weekly"
					? 61
					: freq[0].frequency == "monthly"
					? 92
					: freq[0].frequency == "quarterly"
					? 92
					: 31;
			let diff_days = moment(this.detailedToDate).diff(
				this.detailedFromDate,
				"days"
			);
			console.log(diff_days, "new_days");

			if (diff_days <= days) {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.downloadCsvReport();
					} else {
						alert("Enter required fields");
					}
				});
			} else {
				alert(`Please select less than or equal to ${days} days`);
			}
		},
		downloadCsvReport() {
			this.addDownloadingReportCountAction("Report");
			this.is_csv_loading = true; //displayed loader on button
			// this.addDownloadingReportCountAction();
			var params = {
				start_date: moment(this.detailedFromDate).format("YYYY-MM-DD"),
				end_date: moment(this.detailedToDate).format("YYYY-MM-DD"),
				project: this.project_tasks,
				location: null,
				locations: this.detailedLocations,
			};
			setTimeout(() => {
				this.$emit("close");
			}, 1000);
			formBuilderServices
				.getDashboardDetailedReport(params)
				.then((response) => {
					// console.log(response, "resp");
					// if (response.status == 200) {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					var fileLink = document.createElement("a");
					fileLink.href = fileURL;
					fileLink.setAttribute(
						"download",
						`${
							`${
								this.project_tasksItems.length != 0
									? this.project_tasksItems.filter((el) =>
											el.id.includes(this.project_tasks)
									  )[0].name
									: "-"
							} - ` +
							params.start_date +
							"/" +
							params.end_date +
							".csv"
						}`
					);
					document.body.appendChild(fileLink);
					fileLink.click();
					// }
					// this.removeDownloadingReportCountAction();
					this.removeDownloadingReportCountAction();
					this.is_csv_loading = false; //hide loader on button
				})
				.catch((err) => {
					console.log(err);
					this.removeDownloadingReportCountAction();
					this.is_csv_loading = false; //hide loader on button
					// this.abortDownloadingReportCountAction();
					this.$notify.error({
						title: "Error",
						message: "Something went wrong!",
					});
				});
		},

		handleClose() {
			this.$emit("close");
		},
	},
};
</script>

<style>
.el-select__tags-text {
	text-transform: capitalize;
}
.ns-short-act-dr:hover {
	color: #d26300;
}
</style>
